import constants from 'constants/index'

import { makeStyles } from '@material-ui/core'

const styles = makeStyles((theme) => ({
  outlinedSuccessButton: {
    color: theme.palette.success.main,
    borderColor: theme.palette.success.main,
    '&:hover': {
      borderColor: theme.palette.success.main,
    },
  },
  containerWarningButton: {
    color: theme.palette.common.white,
    backgroundColor: theme.palette.warning.main,
    '&:hover': {
      backgroundColor: theme.palette.warning.dark,
      borderColor: theme.palette.warning.dark,
    },
  },
  containerSuccessButton: {
    color: theme.palette.common.white,
    backgroundColor: theme.palette.success.main,
    '&:hover': {
      backgroundColor: theme.palette.success.dark,
      borderColor: theme.palette.success.dark,
    },
  },
  listActivities: {
    color: constants.alert.CHOOSE_DARK_COLOR_OF_STANDARD.error,
  },
  listItem: {
    margin: 0,
  },
  listItemText: {
    paddingTop: 0,
    paddingBottom: 0,
    marginTop: 0,
    marginBottom: 0,
  },
}))

export default styles
